module.exports = __webpack_public_path__ + "img/account-circle.b0ee3135.svg";